export class ParamDto {
  constructor(
    public evaluationCost: number,
    public subscriptionFee: number,
    public culqiFee: number,
  ){}
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dto/param.dto.ts